import React from "react";
import { Button } from "@mui/material";


export default function BlueLightOutLinedMediumButton({ startIcon,
  buttonTitle,
  onClick,
  endIcon,
  minWidth, textColor,fontWeight,fontSize}) {
  return (
     <Button
      variant="outlined"
      size="small"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      endIcon={endIcon}
      sx={{
        borderRadius: "6px",
        fontSize: fontSize?fontSize : "14px",
        fontWeight:fontWeight ?fontWeight : 700,
      background:"#FFFFFF",
        textTransform: "none",
        border:"1px solid #E7CEF6",
        color: textColor?textColor :"#572575",
        px: 3,
        fontFamily:"Inter",
        boxShadow:" 0px 3px 4px 0px rgba(200, 141, 235, 0.27)",

            minWidth: { minWidth },
        "&:hover" :{
         border:"1px solid #E7CEF6",
           background:"#FFFFFF",
         
        }
       
      }}
    >
      {buttonTitle}
    </Button>
  )
}
